import React from "react";
import { Form, Input, Button } from "antd";

function DynamicList({ name, label, placeholder }) {
  return (
    <Form.Item label={label}>
      <Form.List name={name}>
        {(fields, { add, remove }) => (
          <>
            {fields.map((field) => (
              <div
                key={field.key}
                style={{ display: "flex", gap: 8, marginBottom: 8 }}
              >
                <Form.Item {...field} noStyle>
                  <Input placeholder={placeholder} style={{ flex: 1 }} />
                </Form.Item>
                <Button danger onClick={() => remove(field.name)}>
                  —
                </Button>
              </div>
            ))}
            <Button type="dashed" onClick={() => add()} block>
              + Нэмэх
            </Button>
          </>
        )}
      </Form.List>
    </Form.Item>
  );
}

export default function OverviewSection() {
  return (
    <>
      <DynamicList
        name="keyFacts"
        label="Үндсэн мэдээлэл"
        placeholder="Жишээ: Хугацаа дуусахаас өмнө цуцлахад тооцох хүү 2.4%"
      />
      <DynamicList
        name="pros"
        label="Давуу тал"
        placeholder="Жишээ: Данс нээхэд шимтгэлгүй"
      />
      <DynamicList
        name="cons"
        label="Сул тал"
        placeholder="Жишээ: Эрт цуцлахад хүү алдагдана"
      />
      <DynamicList
        name="nonCashIncomeFee"
        label="Бэлэн бус орлогын шимтгэл"
        placeholder="Жишээ: Шимтгэлгүй"
      />
      <DynamicList
        name="cashIncomeRequirement"
        label="Бэлэн орлогын шаардлага"
        placeholder="Жишээ: Шаардахгүй"
      />
      <DynamicList
        name="withdrawalOptions"
        label="Зарлага гаргах боломж"
        placeholder="Жишээ: Үлдэгдлийн 65% хүртэл"
      />
    </>
  );
}
